import React from "react";

interface gridContext {
  grid: any;
}

export const GridContext = React.createContext<gridContext | null>(null);
